import { useGetByHubWithHierarchySuspenseQuery } from '../../../__generated__/chirp/com/hubspot/teams/rpc/AppFatTeams.hooks';
import { useCaptureError } from '../useCaptureError';
export function useFetchTeams() {
  const {
    error,
    data
  } = useGetByHubWithHierarchySuspenseQuery();
  useCaptureError(error, {
    message: 'Error fetching teams'
  });
  return {
    error,
    data
  };
}